// src/components/SearchBar.js
import React, { useState } from 'react';

const SearchBar = ({ onSearch }) => {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim());
    }
  };

  return (
<form onSubmit={handleSubmit} role="search" className="d-flex align-items-center gap-2">

      <input
        type="text"
        className="border border-gray-300 rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Search..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <button
        type="submit"
        className="btn-sm rounded hover:bg-blue-600 transition"
      >
        🔍
      </button>
    </form>
  );
};

export default SearchBar;
